import type { Landing } from "@propsys/shared";

export function landingPath(l: Landing): string {
  switch (l.kind) {
    case "orgs":
      return "/orgs";
    case "properties":
      return `/o/${l.orgSlug}/properties`;
    case "property":
      return `/o/${l.orgSlug}/p/${l.propertyId}`;
    case "portal":
      return "/portal";
    default:
      return "/welcome";
  }
}
